import classNames from 'classnames'
import { useRouter } from 'next/router'
import { AutoScroll } from '~/components/ui/AutoScroll'
import { getTags_squareModule_squareOptionMenu_createTagOptions } from '~/graphqls/types'

import styles from './ThemeSelect.module.css'

interface Props {
  tagList: getTags_squareModule_squareOptionMenu_createTagOptions[]
}

export default function ThemeSelect({ tagList }: Props) {
  const router = useRouter()
  /** 选中的主题 */
  const themeid = Number(router.query.themeid) || 0
  const changeRoute = (obj: Record<string, number | string>) => {
    router.replace(
      {
        pathname: router.pathname,
        query: {
          ...router.query,
          ...obj,
        },
      },
      undefined,
      { shallow: true }
    )
  }
  const changeTheme = (id: number) => {
    changeRoute({ themeid: id })
  }
  /** 主题tag */
  let themeTag = []
  let themeId2Index: Record<number, number> = {}
  let _tagList = [
    {
      id: 0,
      name: '全部',
      icon: 'https://data.wujiebantu.com/%E5%85%A8%E9%83%A8.png',
    },
    tagList[0],
    {
      id: -1,
      name: '合集',
      icon: 'https://data.wujiebantu.com/FoKziSLuFXVaa901tVgXTGKzK1As.png',
    },
    ...tagList.slice(1),
  ]

  for (let i = 0; i < _tagList.length; ) {
    const a = _tagList[i++]
    const b = _tagList[i++]
    if (b) {
      themeTag.push([a, b])
      themeId2Index[a.id] = Math.floor((i - 1) / 2)
      themeId2Index[b.id] = Math.floor((i - 1) / 2)
    } else {
      themeTag.push([a])
      themeId2Index[a.id] = Math.floor((i - 1) / 2)
    }
  }

  return (
    <AutoScroll activeIndex={themeId2Index[themeid as number]} hasArrow>
      <div className="flex">
        {themeTag.map((item, index) => {
          return (
            <div
              key={index}
              className={classNames({
                'ml-3': index > 0,
              })}
            >
              <div
                className={classNames(styles.theme, {
                  [styles.themeActive]: themeid === item[0].id,
                })}
                style={{
                  backgroundImage: `linear-gradient(
                    to bottom,
                    rgba(0, 0, 0, 0.1),
                    rgba(0, 0, 0, 0.5)
                  ), url(${item[0].icon || ''})`,
                }}
                onClick={() => {
                  changeTheme(item[0].id)
                }}
              >
                <div className={styles.themeHover}>{item[0].name}</div>
              </div>
              {!!item[1] && (
                <div
                  className={classNames(styles.theme, 'mt-2', {
                    [styles.themeActive]: themeid === item[1].id,
                  })}
                  style={{
                    backgroundImage: `linear-gradient(
                      to bottom,
                      rgba(0, 0, 0, 0.1),
                      rgba(0, 0, 0, 0.5)
                    ), url(${item[1].icon})`,
                  }}
                  onClick={() => {
                    changeTheme(item[1].id)
                  }}
                >
                  <div className={styles.themeHover}>{item[1].name}</div>
                </div>
              )}
            </div>
          )
        })}
      </div>
    </AutoScroll>
  )
}
